const illustrators = [
  {
    path: '/',
    name: 'illustrationx home page',
    component: () => import('@/views/illustration/HomePage.vue'),
    alias: ['/us','/br','/cn','/sx','/fr','/sg','/in','/au','/jp','/index.html']
  },
  {
    path: '/:lang?/admin/test-illustration-portfolio/:name',
    name: 'admin nonlive portfolio',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/PortfolioNonLive.vue'),
    props: true
  },
  {
    path: '/login',
    name: 'uni admin login',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AdminLogin.vue')
  },
  {
    path: '/admin/signin-return',
    name: 'uni signin return',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/SigninReturn.vue')
  },
  {
    path: '/admin/signout-return',
    name: 'uni signout return',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/SignoutReturn.vue')
  },
  {
    path: '/not-found',
    name: 'uni not found',
    component: () => import( '@/views/NotFound.vue'),
    alias: '/notfound.html'
  },
  {
    path: '/:lang?/artists',
    component: () => import( '@/views/illustration/ArtistContainer.vue'),
    children: [
      {
        path: '/:lang?/artists',
        name: 'illustrators a-z',
        component: () => import( '@/views/illustration/AllArtists.vue'),
      },
      {
        path: '/:lang?/artists/new',
        name: 'illustrators a-z new',
        component: () => import( '@/views/illustration/AllArtists.vue'),
        props: {
          defaultMode: 'new'
        }
      },
      {
        path: '/:lang?/search/:keyword',
        name: 'Keyword Search',
        component: () => import( '@/views/illustration/KeywordSearch.vue'),
        props: true
      },
      {
        path: '/:lang?/artists/:name',
        name: 'illustration portfolio',
        component: () => import( '@/views/illustration/PortfolioFit.vue'),
        props: true
      },
      {
        path: '/:lang?/artists/:name/styles/:galname',
        name: 'illustrator style selection',
        component: () => import( '@/views/illustration/PortfolioFit.vue'),
        props: true
      },
      {
        path: '/:lang?/artists-fit/:name',
        name: 'illustration portfolio fit',
        component: () => import( '@/views/illustration/PortfolioFit.vue'),
        props: true
      },
      {
        path: '/:lang?/artists/:name/bio',
        redirect: to => {
          let path = to.path
          let wh = path.lastIndexOf('/')
          return path.substring(0, wh)
        }
      },
      {
        path: '/:lang?/artists/:name/view',
        redirect: to => {
          if(!to.params.lang) {
            return `/artists/${to.params.name}`
          }
          return `/${to.params.lang}/artists/${to.params.name}`
        }
      },
      {
        path: '/:lang?/artists/:name/interviews',
        redirect: to => {
          let path = to.path
          let wh = path.lastIndexOf('/')
          return path.substring(0, wh)
        }
      },
      {
        path: '/:lang?/artists/:name/testimonials',
        redirect: to => {
          let path = to.path
          let wh = path.lastIndexOf('/')
          return path.substring(0, wh)
        }
      },
      {
        path: '/:lang?/artists/:name/videos',
        name: 'portfolio videos container',
        component: () => import( '@/views/illustration/PortfolioVideoNews.vue'),
        props: true,
        children: [
          {
            path: '/:lang?/artists/:name/videos',
            name: 'portfolio videos',
            component: () => import('@/views/portfolio/VideoPortfolio.vue'),
          },
          {
            path: '/:lang?/artists/:name/news',
            name: 'portfolio news',
            component: () => import( '@/views/portfolio/NewsPortfolio.vue'),
          }
        ]
      },
      {
        path: '/:lang?/artists/:name/:thing1/:thing2/:thing3?',
        redirect: (to) => {
          if(to.params.lang) {
            return '/' + to.params.lang + '/artists/' + to.params.name
          }
          else {
            return '/artists/' + to.params.name
          }
        }
      }
    ]
  },
  {
    path: '/:lang?/artists/:name/:imageid',
    name: 'uni Single Image View',
    component: () => import( '@/views/illustration/ImagePage.vue'),
    props: true
  },
  {
    path: '/:lang?/styles/:url',
    name: 'illustrator style gallery',
    component: () => import( '@/views/illustration/StyleGalleryV2.vue'),
    props: true
  },
  
  {
    path: '/:lang?/styles',
    redirect: (to) => {
      if(to.params.lang) {
        return '/' + to.params.lang + '/artists'
      }
      else {
        return '/artists'
      }
    }
  },
  {

    path: '/:lang?/applications',
    name: 'artist applications',
    component: () => import( '@/views/ApplicationForm.vue')
  },
  {
    path: '/:lang?/applications/thanks',
    name: 'applications/thanks',
    component: () => import( '@/views/GenericPage.vue')
  },
  {
    path: '/:lang?/disclaimer',
    name: 'disclaimer',
    component: () => import( '@/views/GenericPage.vue')
  },
  {
    path: '/:lang?/terms',
    name: 'terms',
    component: () => import( '@/views/GenericPage.vue')
  },
  {
    path: '/:lang?/privacy-policy',
    name: 'privacy',
    component: () => import( '@/views/GenericPage.vue')
  },
  
  {
    path: '/about',
    component: () => import( '@/StyleBrowseNav.vue'),
    children: [
      {
        path: '/:lang?/about',
        name: 'about us',
        component: () => import( '@/views/about/AboutUs.vue'),
      },
      {
        path: '/:lang?/commissioning',
        name: 'commissioning',
        component: () => import( '@/views/CommissioningPage.vue')
      },
      {
        path: '/:lang?/ten-million-trees',
        name: 'ten million trees',
        component: () => import( '@/views/TenMillionTrees.vue')
      },
      {
        path: '/:lang?/contact/:region',
        name: 'contact',
        component: () => import( '@/views/Contact.vue'),
        props: true
      },
      {
        path: '/:lang?/Contact/:region',
        redirect: to => {
          if(!to.params.lang) {
            return `/contact/${to.params.region}`
          }
          return `/${to.params.lang}/contact/${to.params.region}`
        }
      },
      {
        path: '/:lang?/change-password',
        name: 'changepass',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/myarea/ChangePassword.vue')
      },
      {
        path: '/:lang?/password-reset',
        name: 'resetpass',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/myarea/ResetPassword.vue')
      },
      {
        path: '/:lang?/forgot-password',
        name: 'forgot password',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/myarea/ForgotPass.vue')
      },
      {
        path: '/:lang?/confirm-signup',
        name: 'confirm',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/myarea/ConfirmPage.vue')
      },
      {
        path: '/:lang?/my-area/collections',
        name: 'collections index',
        component: () => import(/* webpackChunkName: "my-area" */ '@/views/myarea/CollectionsPage.vue')
      },
      {
        path: '/:lang?/my-area/collections/view',
        name: 'collection view',
        component: () => import(/* webpackChunkName: "my-area" */ '@/views/myarea/CollectionView.vue')
      },
      {
        path: '/:lang?/my-area/account',
        name: 'myarea account',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/myarea/AccountPage.vue')
      },
      {
        path: '/:lang?/my-area/signup',
        name: 'myarea signup',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/myarea/SignupPage.vue')
      },
      {
        path: '/my-area/view-lightbox/:shortid',
        name: 'uni myarea signup',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/myarea/ViewLightbox.vue'),
        props: true
      }
    ]
  },
  {
    path: '/:lang?/vacancies',
    name: 'vacancies',
    component: () => import( '@/views/VacancyView.vue')
  },
  {
    path: '/:lang?/podcasts',
    name: 'podcasts area',
    component: () => import('../views/podcasts/PodcastContainer.vue'),
    children: [
      {
        path: '/:lang?/podcasts',
        name: 'podcasts list',
        component: () => import('../views/podcasts/PodcastList.vue')
      },
      {
        path: '/:lang?/podcasts/:id/:title',
        name: 'podcast view',
        component: () => import('../views/podcasts/PodcastView.vue'),
        props: true
      }
    ]
  },
  {
    path: '/:lang?/news',
    name: 'news area',
    component: () => import( '@/views/news/NewsContainer.vue'),
    children: [
      {
        path: '/:lang?/news/tags/:tagname',
        name: 'news by tag',
        component: () => import( '@/views/news/NewsHome.vue'),
        props: true
      },
      
      {
        path: '/:lang?/news',
        name: 'news home',
        component: () => import( '@/views/news/NewsHome.vue')
      }
    ]
  },
  {
    path: '/:lang?/news/:id/:title',
    name: 'news item',
    component: () => import( '@/views/news/NewsItem.vue'),
    props: true
  },
  {
    path: '/:lang?/videos/tags/:tagname',
    name: 'videos by tag',
    component: () => import( '@/views/videos/VideoHome.vue'),
    props: true
  },
  {
    path: '/:lang?/videos/:id/:title',
    name: 'video item',
    component: () => import( '@/views/videos/VideoHome.vue'),
    props: true
  },
  
  {
    path: '/:lang?/videos',
    name: 'video home',
    component: () => import( '@/views/videos/VideoHome.vue')
  },
  {
    path: '/:lang?/best-of-illustrationx',
    name: 'hero images',
    component: () => import( '@/views/illustration/HeroImages.vue')
  }
]

export default illustrators